import type {
	ProgressSpinnerDesignTokens,
	ProgressSpinnerTokenSections,
} from '@openng/optimus-ui-themes/types/progressspinner';

export const colorScheme: ProgressSpinnerTokenSections.ColorScheme = {
	light: {
		root: {
			colorTwo: '{primary.500}',
		},
	},
};

export default {
	colorScheme,
} satisfies ProgressSpinnerDesignTokens;
